import { render, staticRenderFns } from "./GenerateReportConfirmationModal.vue?vue&type=template&id=a4612bde&"
import script from "./GenerateReportConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./GenerateReportConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QBtn} from 'quasar'
component.options.components = Object.assign({QList,QItem,QItemSection,QBtn}, component.options.components || {})
